import React from "react";
import { projects } from "../../constants";
const Projects = () => {
  return (
    <section class="portfolio section" id="portfolio">
      <h2 class="section-title">
        My Recent <span class="purple">Works</span>
      </h2>
      <div class="portfolio-container bd-grid">
        {projects.map((project, index) => (
          <div class="portfolio-img" key={index}>
            <img src={project.image} alt="project-img" />
            <h2 style={{ textAlign: "center" }}>{project.title}</h2>
            <p>{project.description}</p>
            <br />
            <p>{project.techStack.join(" | ")}</p>
            <div class="portfolio-link bd-grid">
              <a
                class="portfolio-link-name"
                href={project.liveLink}
                target="_blank"
                rel="noreferrer"
              >
                Demo
              </a>
              <a
                class="portfolio-link-name"
                href={project.githubLink}
                target="_blank"
                rel="noreferrer"
              >
                Code
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;
